var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React, { Component } from "react";
import { withTheme } from "styled-components";
import IconBase from "@irati/ui/src/Icon";
import Number from "./Number";
import { Wrapper, WrapperNoNumber, TextButton } from "../styled";
var Icon = /** @class */ (function (_super) {
    __extends(Icon, _super);
    function Icon() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.state = {
            hover: false
        };
        _this.handleMouseOver = function () { return _this.setState({ hover: true }); };
        _this.handleMouseOut = function () { return _this.setState({ hover: false }); };
        return _this;
    }
    Icon.prototype.render = function () {
        var hover = this.state.hover;
        var _a = this.props, onClick = _a.onClick, icon = _a.icon, number = _a.number, id = _a.id, theme = _a.theme, props = __rest(_a, ["onClick", "icon", "number", "id", "theme"]);
        var hasNumber = number > 0;
        var Container = hasNumber ? Wrapper : WrapperNoNumber;
        return (React.createElement(TextButton, { onClick: onClick, id: id },
            React.createElement(Container, __assign({}, props, { onMouseOver: this.handleMouseOver, onMouseOut: this.handleMouseOut }),
                React.createElement(IconBase, { icon: icon, color: hover || props.active ? theme.colors.primary1 : theme.colors.utility.ink }),
                hasNumber && React.createElement(Number, null, number))));
    };
    Icon.defaultProps = {
        active: false,
        number: 0,
        onClick: function () { }
    };
    return Icon;
}(Component));
export default withTheme(Icon);
